exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachedPdf[data-v-0df6ab63]{width:100px!important}", ""]);

// exports
